/** GROQ's range end is inclusive: nine posts are [0..8], [9..17], etc. */
export const BLOG_PAGE_SIZE = 9;

export function blogPageHref(pathname: string, page: number): string {
  return page > 1 ? `${pathname}?page=${page}` : pathname;
}

export function blogPagination(requestUrl: string) {
  const url = new URL(requestUrl);
  const rawPage = url.searchParams.get('page');
  const legacyStart = Number(url.searchParams.get('start') ?? '0');
  const parsedPage =
    rawPage === null
      ? Math.floor(Math.max(0, legacyStart) / BLOG_PAGE_SIZE) + 1
      : Number(rawPage);
  const page =
    Number.isSafeInteger(parsedPage) &&
    parsedPage > 0 &&
    parsedPage <= Math.floor(Number.MAX_SAFE_INTEGER / BLOG_PAGE_SIZE)
      ? parsedPage
      : 1;
  const start = (page - 1) * BLOG_PAGE_SIZE;
  const end = start + BLOG_PAGE_SIZE - 1;
  const needsRedirect =
    url.searchParams.has('start') ||
    url.searchParams.has('end') ||
    url.searchParams.getAll('page').length > 1 ||
    (rawPage !== null && (page === 1 || rawPage !== String(page)));

  return {
    page,
    start: String(start),
    end: String(end),
    redirectTo: needsRedirect ? blogPageHref(url.pathname, page) : undefined,
  };
}
